import { BranchCode, RiskSummaryDto } from "api/risk";
import { GenericColors } from "enums/genericColors";
import { SimulationTableRowKey } from "../types/enums";
import { SimulationRow } from "../types/interfaces";

/**
 * Mappe un RiskSummaryDto vers un objet Simulation
 * @param riskSummary - L'objet RiskSummaryDto à mapper
 * @returns L'objet Simulation mappé
 */
export function mapRiskSummaryToSimulation(riskSummary: RiskSummaryDto): SimulationRow {
  const getQuoteContract = () => {
    if (riskSummary.quoteIdentifiers && riskSummary.quoteIdentifiers?.length > 0) {
      return riskSummary.quoteIdentifiers.map((quote) => quote)
    }

    if (riskSummary.contractIdentifier) {
      return [riskSummary.contractIdentifier]
    }

    return [{ id: '_', label: '_' }]
  }

  return {
    id: riskSummary.id,
    riskId: riskSummary.id,
    borrowerProjectId: riskSummary.borrowerProjectId ?? undefined,
    [SimulationTableRowKey.DATE]: riskSummary.date.toISOString(),
    [SimulationTableRowKey.STATUS]: {
      label: riskSummary.statusLabel,
      color: riskSummary.statusColor as GenericColors,
    },
    [SimulationTableRowKey.QUOTE_CONTRACT]: getQuoteContract(),
    [SimulationTableRowKey.FOLDER_IDENTIFIER]: { ...riskSummary.simulationIdentifier, branchCode: riskSummary.branchCode as BranchCode },
    [SimulationTableRowKey.SOURCE]: riskSummary.sourceLabel ?? '—',
    sourceCode: riskSummary.sourceCode ?? undefined,
    [SimulationTableRowKey.INSUREDS]: riskSummary.insureds ? riskSummary.insureds.map(item => item.label).join(', ') : '', // Concatène les labels
    [SimulationTableRowKey.BRANCH]: riskSummary.branchCode,
    [SimulationTableRowKey.PRODUCTS]: riskSummary.products.join(', '), // Concatène les produits
    [SimulationTableRowKey.UNREAD_NOTIFICATION_COUNT]: riskSummary.unreadNotificationCount || 0,
  };
}

/**
 * Mappe un tableau de RiskSummaryDto vers un tableau de Simulation
 * @param riskSummaries - Le tableau de RiskSummaryDto à mapper
 * @returns Le tableau de Simulation mappé
 */
export function mapRiskSummariesToSimulations(riskSummaries: RiskSummaryDto[]): SimulationRow[] {
  return riskSummaries.map(mapRiskSummaryToSimulation);
}
